import axios from "axios";

const messsages = axios.create({
  baseURL: process.env.REACT_APP_MESSAGES,
  headers: {
    'Accept': 'application/json; charset=UTF-8',
    'Content-Type': 'application/json; charset=UTF-8', 
  },  
});

export default messsages;